// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".opacity-0[data-v-673c1251]{opacity:0}.v-btn[data-v-673c1251]{border-radius:.4rem}.v-card[data-v-673c1251]:last-child{border-bottom-left-radius:12px !important;border-bottom-right-radius:12px !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
